<template>
  <div class="imports-page">
    <app-page-header title="Importações"></app-page-header>
    <imports-table ref="importsTable"></imports-table>
  </div>
</template>

<script>
import ImportsTable from '@/components/Tables/ImportsTable.vue';

export default {
  name: 'imports-page',
  components: {
    ImportsTable,
  },
};
</script>

<style lang="scss" scoped></style>
